<h2 mat-dialog-title>{{ data?.id ? ("test_edit" | transloco) : ("test_create" | transloco) }}</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-dialog-content
        [formGroup]="form"
        class="grid"
    >
        <mat-form-field class="full-width">
            <mat-label>{{ "name" | transloco }}</mat-label>
            <input
                matInput
                formControlName="name"
            />
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ "application" | transloco }}</mat-label>
            <mat-select formControlName="consumers">
                @for (consumer of consumers$ | async; track consumer) {
                <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ "subject" | transloco }}</mat-label>
            <mat-select formControlName="subjects">
                @for (subject of subjects$ | async; track subject) {
                <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <div class="border-area full-width">
            <div class="multi-select mt-2">
                <pixl-multi-combo-entity-search
                    [label]="'sequences' | transloco"
                    [observable$]="sequences$"
                    [namingColumn]="'name'"
                    [externalSearch]="true"
                    (onStateChange)="receiveSequenceData($event)"
                    (onSearchChange)="receiveSequenceSearchQuery($event)"
                    (scrolledToEnd)="loadMoreSequences($event)"
                    [(selectedValues)]="selectedSequences"
                >
                </pixl-multi-combo-entity-search>
            </div>
            <div class="mb-1">{{ "arrange_drag_drop" | transloco }}</div>
            <div
                cdkDropList
                class="order-list"
                (cdkDropListDropped)="reOrderSelectedSequences($event)"
            >
                @for (sequence of selectedSequences; track trackById($index, sequence)) {
                <div
                    class="order-box"
                    cdkDrag
                >
                    {{ sequence.name }}
                </div>
                }
            </div>
        </div>
    </mat-dialog-content>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button
            mat-button
            (click)="cancel()"
        >{{ "cancel" | transloco }}</button>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="form.invalid"
        >{{ "save" | transloco }}</button>
    </mat-dialog-actions>
</div>